module.exports = "https://r.zoocdn.com/_next/static/images/favicon-b2be8fc5a988bfb80c434b03cb9b6708.ico";